import * as React from 'react';
import { KeyboardEventHandler, MouseEventHandler, TouchEventHandler } from 'react';
import { useHover } from '@react-aria/interactions';
import { useMediaQuery, useIsActive } from '../../../../hooks';

type LinkStyleProps = {
    decorator: string,
    disabled: boolean | undefined,
    onKeyDown?: KeyboardEventHandler,
    onKeyUp?: KeyboardEventHandler,
    onMouseDown?: MouseEventHandler,
    onMouseUp?: MouseEventHandler,
    onTouchStart?: TouchEventHandler,
    onTouchEnd?: TouchEventHandler
}

export const useLinkStyle = ({
    decorator = 'always', 
    disabled = false,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseUp,
    onTouchStart,
    onTouchEnd
}: LinkStyleProps) => {

    let { hoverProps, isHovered } = useHover({});
    let { isActiveProps, isActive } = useIsActive({
        disabled: disabled,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
      });
    let actionStateProps = {
        ...isActiveProps,
        ...hoverProps,
    }

    const isMobile = useMediaQuery({max: 'md'});

    const getLinkStyle = React.useCallback(() => {
        let showStyle = true;
        
        if((decorator === 'none') || (isMobile && decorator === 'desktop') || (!isMobile && decorator === 'mobile')) {
            showStyle = false;
        }

        return showStyle;
    }, [decorator, disabled, isMobile]);

    const [showLinkStyle, setShowLinkStyle] = React.useState(getLinkStyle());

    React.useEffect(() => {      
        const updateLinkStyle = () => {
            let enableLinkStyle = getLinkStyle();
            if(showLinkStyle !== enableLinkStyle) {
                setShowLinkStyle(enableLinkStyle);
            }
        }

        updateLinkStyle();

        return () => {}
    }, [decorator, disabled, isMobile]);

    return {
        actionStateProps,
        isHovered, 
        isActive, 
        showLinkStyle
    }
};